export default function FormEntityInviteUserTeam(user,userInvited,team) {
  return {
      invited_by:user,
      invited_user:userInvited,
      team_id:team
  }
}
